var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCriticaCare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.0659 4.7998C4.82879 4.7998 4.60139 4.89463 4.43373 5.06341C4.26607 5.23219 4.17188 5.46111 4.17188 5.6998V20.0638C4.17188 20.3025 4.26607 20.5314 4.43373 20.7002C4.60139 20.869 4.82879 20.9638 5.0659 20.9638H14.0061V22.8916H9.94905V24.6916H19.8522V22.8916H15.7942V20.9629H24.7344C24.9715 20.9629 25.1989 20.8681 25.3666 20.6993C25.5342 20.5305 25.6284 20.3016 25.6284 20.0629V5.6998C25.6284 5.46111 25.5342 5.23219 25.3666 5.06341C25.1989 4.89463 24.9715 4.7998 24.7344 4.7998H5.0659ZM13.923 7.2244L10.8806 12.6109H5.82224V14.3992H11.9311L13.3785 11.8369L15.0691 17.7301L19.0296 12.6604H23.0796C23.3164 12.6616 23.544 12.5682 23.7124 12.4006C23.8809 12.2331 23.9764 12.0051 23.9781 11.7667C23.9767 11.5282 23.8812 11.3 23.7127 11.1322C23.5443 10.9645 23.3165 10.8709 23.0796 10.8721H18.1508L15.8246 13.8511L13.923 7.2244Z",
    fill: "#2EAD9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriticaCare);
export default __webpack_public_path__ + "static/media/critica-care.b27173e212a43471cdf1640bfdcf2a29.svg";
export { ForwardRef as ReactComponent };